export const GET_RECOMMENDS = 'GET_RECOMMENDS';
export const SET_RECOMMENDS = 'SET_RECOMMENDS';
export const GET_JSONPLACEHOLDER = 'GET_JSONPLACEHOLDER';
export const REMOVE_RECOMMEND = 'REMOVE_RECOMMEND';
export const SET_RECOMMENDS_SUCCESS = 'SET_RECOMMENDS_SUCCESS';
export const SET_RECOMMENDS_SYNC = 'SET_RECOMMENDS_SYNC';
